<template>
  <div class="projet-part">
    <h2 id="autre">{{ $t("projetPage.mon-annee.autres-infos.titre") }}</h2>

    <InputWithValidation
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      type="textarea"
      :label="$t('projetPage.mon-annee.autres-infos.autres-infos')"
      :input-notice="$t('projetPage.mon-annee.autres-infos.autres-infos-hint')"
      maxlength="1400"
      :model-value="projetAnnuel.autresInfos"
      :disabled="readonly || !isPorteurProjet"
      vid="autre_procedesDeterminationActions"
      @update:model-value="updateAutresInfos"
      @manual-change="changeAutresInfos"
    />
    <FileWithValidation
      :label="$t(`projetPage.mon-annee.etat-des-lieux.fichier-titre`)"
      :validation-activated="validationActivated"
      :show-validation-errors="showValidationErrors"
      :placeholder="$t(`projetPage.infoAdministratives.charte.televerser`)"
      :input-notice="$t('projetPage.mon-annee.autres-infos.autres-infos-fichier-message')"
      :file-operation-url="autresInfosFileUrl"
      :disabled="readonly"
      vid="autre_fichierProblematiques"
      :model-value="projetAnnuel.autresInfosFilePresent"
      default-file-name="FICHIER_COMPLEMENTAIRE.pdf"
      :rules="projetAnnuel.typeDossier === 'DOSSIER_RENOUVELLEMENT_LIGHT' ? 'required' : ''"
      @add-file="addFile"
      @delete-file="deleteFile"
    />
  </div>
</template>

<script lang="ts">
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import { defineComponent } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import FileWithValidation from "@/views/inputs/FileWithValidation.vue"
import { FileService } from "@/services/rest/utils/FileService"

export default defineComponent({
  name: "AutresInfosView",
  components: { InputWithValidation, FileWithValidation },
  props: {
    projetAnnuel: {
      type: Object as () => ProjetAnnuelDTO,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isPorteurProjet: {
      type: Boolean,
      default: false,
    },
    validationActivated: {
      type: Boolean,
      default: false,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["projet-updated", "dirtify-project", "trigger-validation"],
  data() {
    return {
      fileService: FileService.INSTANCE,
      autresInfosFileUrl: "",
    }
  },
  watch: {
    projetAnnuel(): void {
      this.dossierChanged()
    },
  },
  created() {
    if (this.projetAnnuel.id) {
      this.autresInfosFileUrl = this.fileService.buildUniqueFileURL(
        this.projetAnnuel.id,
        "FICHIER_COMPLEMENTAIRE",
      )
    }
  },
  methods: {
    dossierChanged(): void {
      if (!this.projetAnnuel || !this.projetAnnuel.id) {
        return
      }
      this.autresInfosFileUrl = this.fileService.buildUniqueFileURL(
        this.projetAnnuel.id,
        "FICHIER_COMPLEMENTAIRE",
      )
    },

    updateAutresInfos(value: string): void {
      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        autresInfos: value,
      }
      this.$emit("projet-updated", updatedProjetAnnuel)
    },

    changeAutresInfos(): void {
      this.$emit("dirtify-project")
    },

    addFile(): void {
      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        autresInfosFilePresent: true,
      }
      this.$emit("projet-updated", updatedProjetAnnuel)
      this.$emit("trigger-validation")
    },

    deleteFile(): void {
      const updatedProjetAnnuel = {
        ...this.projetAnnuel,
        autresInfosFilePresent: false,
      }
      this.$emit("projet-updated", updatedProjetAnnuel)
      this.$emit("trigger-validation")
    },
  },
})
</script>

<style lang="scss"></style>
